import { z } from "zod";

export const formSchema = z.object({
    outgoingPostback: z.string(),
});

export type ModifyPostbackOutgoingFormData = z.infer<typeof formSchema>;
